import React, { useEffect, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import './AnalyticsConsent.css';
import {
  getConsentStatus,
  isAnalyticsEnabled,
  setConsentStatus,
  trackEvent
} from '../../utils/analytics';
import { shouldShowMobileInterface } from '../../utils/mobileDetection';

const AnalyticsConsent = ({ isMobile }) => {
  const { t } = useTranslation('mobile', { useSuspense: false });
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  const isMobileUi = useMemo(() => {
    if (typeof isMobile === 'boolean') {
      return isMobile;
    }
    return shouldShowMobileInterface();
  }, [isMobile]);

  useEffect(() => {
    if (!isAnalyticsEnabled()) return;

    const status = getConsentStatus();
    if (status === 'unknown') {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    setConsentStatus('granted', { source: 'app_banner' });
    setIsDismissed(true);
    setIsVisible(false);
    trackEvent('consent_granted', { consent_source: 'app_banner' });
  };

  const handleReject = () => {
    setConsentStatus('denied', { source: 'app_banner' });
    setIsDismissed(true);
    setIsVisible(false);
  };

  if (!isVisible || isDismissed) {
    return null;
  }

  return (
    <div className={`loopino-consent-banner ${isMobileUi ? 'is-mobile' : 'is-desktop'}`} role="dialog" aria-live="polite">
      <div className="loopino-consent-panel" role="document">
        <div className="loopino-consent-copy">
          <p className="loopino-consent-eyebrow">{t('analyticsConsent.eyebrow', { defaultValue: 'Loopino privacy' })}</p>
          <h3 className="loopino-consent-title">{t('analyticsConsent.title', { defaultValue: 'Analytics to improve Loopino' })}</h3>
          <p className="loopino-consent-description">
            {t('analyticsConsent.description', {
              defaultValue: 'We use analytics cookies to understand what works and make the platform more useful. You can choose now whether to accept or reject.'
            })}
          </p>
        </div>

        <div className="loopino-consent-actions">
          <a className="loopino-consent-link" href="/cookies">
            {t('analyticsConsent.cookiePolicy', { defaultValue: 'Cookie policy' })}
          </a>
          <button className="loopino-consent-button secondary" type="button" onClick={handleReject}>
            {t('common.actions.reject', { defaultValue: 'Reject' })}
          </button>
          <button className="loopino-consent-button primary" type="button" onClick={handleAccept}>
            {t('common.actions.accept', { defaultValue: 'Accept' })}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsConsent;
